@if(notFoundComponent()){
<ng-container
        *ngComponentOutlet="
          notFoundComponent();
        "
      >
  </ng-container>
}@else {
  <ng-container *ngIf="isLoading()">
    <div
      class="fixed w-screen h-full flex justify-center items-center bg-black bg-opacity-10 z-50"
    >
      <progress-bar [loaderWidth]="'50px'" [loaderHeight]="'50px'" [borderWidth]="'4px'" [borderColor]="'#162F4D'"></progress-bar>
    </div>
  </ng-container>
  
  @if (slotsLoaded() && headerSlots().length) {
    <div
      class="sm:container-fluid sm:m-auto sticky top-0 z-50 bg-white shadow"
      [ngClass]="this.widgetsService.cssClassMap.get(headerSlots()[0].id)"
      [ngStyle]="this.widgetsService.cssStylesMap.get(headerSlots()[0].id)"
    >
      <ng-container
        *ngComponentOutlet="
          viewContainer();
          inputs: {
            dynamicSlots: dynamicSlots(),
            autoSuggestMenuData: suggestions(),
            userContextDto: userContext(),
            inputUserSession: userSession(),
            actionResponseContext: actionResponseContext(),
            parentId: headerSlots()[0].id,
            allChildData: getRequiredDataforHeaderLogical(headerSlots()[0].id),
            childArrangement: headerSlots()[0].childArrangement,
            allSlotsData: headerSlots(),
            layoutParams: headerSlots()[0].layoutParams,
            containerStyle: this.widgetsService.cssStylesMap.get(
              headerSlots()[0].id
            ),
            actionEvent: actionInput,
          }
        "
      ></ng-container>
    </div>
  }
  
  @if (slotsLoaded() && slots().length) {
    @let class = widgetsService.cssClassMap.get(slots()[0].id);
    @let containerClass = !class.includes('container') ? 'container-fluid' : '';
    <div
      class="m-auto"
      [ngClass]="class + containerClass"
      [ngStyle]="widgetsService.cssStylesMap.get(slots()[0].id)"
    >
      <ng-container
        *ngComponentOutlet="
          viewContainer();
          inputs: {
            dynamicSlots: dynamicSlots(),
            parentId: slots()[0].id,
            allChildData: getRequiredDataforLogical(slots()[0].id),
            childArrangement: slots()[0].childArrangement,
            allSlotsData: slots(),
            layoutParams: slots()[0].layoutParams,
            containerStyle: widgetsService.cssStylesMap.get(slots()[0].id),
            actionEvent: actionInput,
            inputUserSession: userSession(),
            userContextDto: userContext(),
          }
        "
      ></ng-container>
    </div>
      
    @if (footerSlots().length && footerComponent()) {
      @defer (hydrate on viewport) {
        <ng-container
          *ngComponentOutlet="
            footerComponent();
            inputs: {
              allSlotsData: footerSlots(),
              actionEvent: actionInput,
            }
          "
        ></ng-container>
      }
    }
  } @else {
    <div class="flex justify-center items-center h-dvh w-full">
       <progress-bar [loaderWidth]="'50px'" [loaderHeight]="'50px'" [borderWidth]="'4px'" [borderColor]="'#162F4D'"></progress-bar>
    </div>
  }
}
